import React, { useEffect } from 'react';
import { initMetaPixel, META_PIXEL_ID } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { QuickTestimonials } from './components/QuickTestimonials';
import { Problems } from './components/Problems';
import { SystemOverview } from './components/SystemOverview';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { LaunchUrgency } from './components/LaunchUrgency';
import { Offer } from './components/Offer';
import { TestimonialWall } from './components/TestimonialWall';
import { Guarantee } from './components/Guarantee';
import { FormatNotice } from './components/FormatNotice';
import { Faqs } from './components/Faqs';
import { Contact } from './components/Contact';
import { Comparison } from './components/Comparison';
import { FinalCall } from './components/FinalCall';
import { ClosingWords } from './components/ClosingWords';
import { SiteFooter } from './components/SiteFooter';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-paper font-sans text-ink" data-id="element-0" data-mp="3mkhn9wh6j873">
      <noscript data-id="element-1" data-mp="3rc9e8848zfxr">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="3rbra6pbcfxfa" />
      </noscript>
      <Hero data-id="element-3" data-mp="2zm4xqkjlzd1t" />
      <SocialProofBar data-id="element-4" data-mp="2zmo3z3zwcd00" />
      <QuickTestimonials data-id="element-5" data-mp="2zn6cp03qwjot" />
      <Problems data-id="element-6" data-mp="33mf1rrnubte1" />
      <SystemOverview data-id="element-7" data-mp="33lwzadal4ixo" />
      <Volumes data-id="element-8" data-mp="33ngiabnml835" />
      <Bonuses data-id="element-9" data-mp="33mylndx1wrup" />
      <LaunchUrgency data-id="element-10" data-mp="33oi1x4ipj2wh" />
      <Offer data-id="element-11" data-mp="38m1iwc6shts4" />
      <TestimonialWall data-id="element-12" data-mp="38li7lebna3n2" />
      <Guarantee data-id="element-13" data-mp="38k6u2msedhir" />
      <FormatNotice data-id="element-14" data-mp="38nup5qdhqbzl" />
      <Faqs data-id="element-15" data-mp="3dkuws5pznmst" />
      <Comparison data-id="element-16" data-mp="3dkl0y1i9ilf7" />
      <FinalCall data-id="element-17" data-mp="3dlw727z6k59h" />
      <ClosingWords data-id="element-18" data-mp="3dmfq5s0kgzp3" />
      <Contact data-id="element-19" data-mp="3dirtwl3qlz6o" />
      <SiteFooter data-id="element-20" data-mp="nvj4pj9gikrb" />
    </div>;
}